module.exports = __webpack_public_path__ + "static/img/0773.c99a75c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/0773.jpg
// module id = 111
// module chunks = 0